module.exports = __webpack_public_path__ + "img/about-1.586ea951.png";